import React from "react";
import { LostUnitsForm } from "./LostUnitsForm";
import { useParams } from "react-router";

export const LostUnitsEdit: React.FC = () => {
  const { recordId } = useParams() as any;

  return (
    <div>
      <LostUnitsForm recordId={recordId} />
    </div>
  );
};
